angular.module('Itao.IndicatorMap').directive('overviewPersonalChart', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var compose = d3.hyperion.compose;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var overviewPersonalChart = function () {
    var svgWidth = 600,
      svgHeight = 350,
      colors = ['#0075a1', '#e17c00', '#366666', '#c5bd76', '#700030', '#64B0CA'],
      duration = 400,
      hideLines = false,
      margin = {top: 30, right: 5, bottom: 10, left: 24},
      numberFormat = germanNumberFormat(',.1f');

    var chart = function (selection) {
      selection.each(function (data) {
        //calculate min and max values and check that 0 is included
        var minValue = 0;
        var maxValue = d3.max(data);

        var numberOfBars = data.length;
        maxValue = maxValue <= 15 ? 15 : maxValue;

        var axisFormatString = ',.0f';

        var container = d3.select(this).datum([data]).classed('bar-chart', true);

        svgWidth = svgWidth ? svgWidth : selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        var colorFromBar = function (d, i) {
          return colors[i];
        };

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for each bar per district
        var x = d3.scale.ordinal()
          .domain([0, 1, 2, 3, 4, 5].slice(0, numberOfBars)) // use only active indicators
          .rangeRoundBands([0, width], 0.3);

        var paddingAround = 20.5; // rangeRoundBands arg 4 in px - fixed...

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxValue])
          .nice();

        // var tickCount = Math.min(svgHeight / 40, 10);
        var tickCount = 4;

        g.call(d3.hyperion.addHorizontalGridLines(y, width, 0, tickCount, duration));

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(function (d) {
            return d ? germanNumberFormat(axisFormatString)(d) : '';
          });

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .transition().duration(duration)
          .call(yAxis);

        // g.call(d3.hyperion.addHorizontalHighlightLines([3,7.5], y, width, duration));

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'left')
          .attr('x', 0)
          .attr('dominant-baseline', 'text-before-edge')
          .text('1 : x');

        var highlightData = [];
        if(!hideLines) {
          highlightData = [3.0, 3.0, 7.5, 4.9, 3.75, null].slice(0, numberOfBars);
        }
        var paddingHighlightLineAndArea = (((width - (paddingAround * 2)) / numberOfBars) - x.rangeBand()) / 2;

        var hightlightAreas = g.selectAll('.highlightArea')
          .data(highlightData);

        // draw new bars
        hightlightAreas
          .enter()
          .append('rect')
          .attr('width', 0)
          .attr('class', 'highlightArea')
          .attr('x', compose(x, sortedAccessor))
          .attr('y', y(0))
          .attr('height', 0);

        // update all areas
        hightlightAreas
          .attr('width', x.rangeBand() + (paddingHighlightLineAndArea * 2))
          .attr('x', function (d, i) {
            return x(i) - paddingHighlightLineAndArea;
          })
          .attr('y', function (d) {
            return d ? y(d) : y(0);
          })
          .attr('height', function (d) {
            return d ? Math.abs(y(0) - y(d)) : 0;
          });

        // remove unused areas
        hightlightAreas.exit()
          .remove();

        var bars = g.selectAll('rect.value-bar')
          .data(data);

        // draw new bars
        bars
          .enter()
          .append('rect')
          .attr('class', 'value-bar')
          .style('fill', colorFromBar)
          .attr('width', 0)
          .attr('x', compose(x, sortedAccessor))
          .attr('y', y(0))
          .attr('height', 0);

        // update all bars
        bars
          .style('fill', colorFromBar)
          .attr('width', x.rangeBand())
          .attr('x', compose(x, sortedAccessor))
          .attr('y', function (d) {
            return d ? y(d) : y(0);
          })
          .attr('height', function (d) {
            return d ? Math.abs(y(0) - y(d)) : 0;
          });

        // remove unused bars
        bars.exit()
          .remove();

        var barLines = g.selectAll('line.bar-line')
          .data(highlightData);

        // draw new lines
        barLines
          .enter()
          .append('line')
          .attr('class', 'bar-line')
          .style('stroke-width', '0')
          .attr('pointer-events', 'none')
          .attr('x1', 0)
          .attr('x2', 0)
          .attr('y1', y(0))
          .attr('y2', y(0));

        // update all bars
        barLines
          .style('stroke-width', function (d) {
            return d ? '4' : '0';
          })
          .attr('x1', function (d, i) {
            return x(i) - paddingHighlightLineAndArea;
          })
          .attr('x2', function (d, i) {
            return x(i) + x.rangeBand() + paddingHighlightLineAndArea;
          })
          .attr('y1', function (d) {
            return d ? y(d) : y(0);
          })
          .attr('y2', function (d) {
            return d ? y(d) : y(0);
          });

        // remove unused bars
        barLines.exit()
          .remove();

        var barLabels = g.selectAll('.barLabel')
          .data(data);

        barLabels.enter()
          .append('text')
          .attr('class', 'barLabel')
          .attr('text-anchor', 'middle');

        barLabels
          .attr('x', function (d, i) {
            return x(i) + (x.rangeBand() / 2);
          })
          .attr('y', function (d) {
            return d ? y(d) - 15 : y(0)-10;
          })
          .text(function (d) {
            return d ? '1 : ' + numberFormat(d) : '—';
          });

        barLabels.exit()
          .remove();
      });
    };

    /**
     * getter/setter for svgWidth
     * @param {Function} [newSvgWidth] new svgWidth function
     * @returns {*}
     */
    chart.svgWidth = function (newSvgWidth) {
      if (!arguments.length) {
        return svgWidth;
      } else {
        svgWidth = newSvgWidth;
        return chart;
      }
    };

    /**
     * getter/setter for svgWidth
     * @param {Function} [newHideLines] new svgWidth function
     * @returns {*}
     */
    chart.hideLines = function (newHideLines) {
      if (!arguments.length) {
        return hideLines;
      } else {
        hideLines = newHideLines;
        return chart;
      }
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'overviewPersonalChart.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '=',
      indicatorUids: '=',
      hideRedLines: '=',
      numberOfDisplayedBars: '=',
      svgWidth: '@'
    },
    link: function (scope, element) {

      var overviewPersonalChartFunction = overviewPersonalChart();

      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {
        var indicatorsToDisplay;
        if (scope.selectedDataLayer != null && scope.selectedDistrict != null && angular.isArray(scope.indicatorUids) && scope.selectedDataLayer.hasOwnProperty(scope.selectedDistrict.uid)) {

          if (scope.numberOfDisplayedBars) {
            indicatorsToDisplay = scope.indicatorUids.slice(0, scope.numberOfDisplayedBars); // dont display sixt bar... Hortgruppen ->
          }

          var values = indicatorsToDisplay.map(function (uid) {
            return scope.selectedDataLayer[scope.selectedDistrict.uid][uid];
          });

          overviewPersonalChartFunction.svgWidth(scope.svgWidth).hideLines(scope.hideRedLines);

          d3.select(element.find('.widget-inner:first')[0])
            .data([values])
            .call(overviewPersonalChartFunction);
        }
      };

      var selectedDataLayerWatcher = scope.$watch('selectedDataLayer', rerender);
      var selectedDistrictWatcher = scope.$watch('selectedDistrict', rerender);
      var indicatorUidsIndicators = scope.$watchCollection('indicatorUids', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        selectedDataLayerWatcher();
        selectedDistrictWatcher();
        indicatorUidsIndicators();
      });
    }
  };
});
